import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type PartnerRow = {
  id: string;
  company_name: string;
  partner_type: string;
  tier: string;
  status: string;
  primary_contact_name: string | null;
  primary_contact_email: string | null;
  website: string | null;
  region: string | null;
  notes: string | null;
  assigned_owner: string | null;
  hubspot_partner_record_id: string | null;
  hubspot_company_id: string | null;
  // 0091: link to the integrations-marketplace listing (PARTNER_COLUMNS
  // includes the column). null = no public marketplace listing.
  marketplace_integration_id: number | null;
  created_at: string;
  updated_at: string;
};

// GET /api/partners — admin partner-list grid.
export function usePartners() {
  return useQuery<PartnerRow[], ApiClientError>({
    queryKey: queryKeys.partners.list(),
    queryFn: () => apiFetch<PartnerRow[]>("/partners"),
  });
}
